<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
  title: string;
  coin: number;
  currentProgress?: number;
  maxProgress?: number;
  resetIfFinished?: boolean;
}>();
const displayCurrentProgress = computed(() => {
  if (props.resetIfFinished && props.currentProgress === props.maxProgress) {
    return 0;
  } else {
    return props.currentProgress;
  }
});
</script>
<template>
  <div class="flex justify-between items-center bg-neutral p-3 rounded">
    <div class="flex gap-3 items-center">
      <slot name="icon">
        <i class="iconify mingcute--comment-line"></i>
      </slot>
      <div class="flex flex-col gap-1">
        <span>{{ title }}</span>
        <span class="text-primary">
          <i class="iconfont icon-coin text-xs" /> +{{ coin }}
        </span>
      </div>
    </div>
    <slot name="right">
      <div class="flex flex-col gap-1 items-end">
        <div class="flex items-center justify-center gap-1">
          <check-outline-icon
            v-if="displayCurrentProgress === maxProgress"
            class="icon-base text-success"
          />
          <span> {{ displayCurrentProgress }}/{{ maxProgress }} </span>
        </div>
        <progress
          :max="maxProgress"
          :value="displayCurrentProgress"
          class="progress w-20 progress-primary"
        ></progress>
      </div>
      <!--      <button class="btn btn-sm btn-primary rounded">签到</button>-->
    </slot>
  </div>
</template>
